<script lang="ts">
    import type { IconAnimated } from "@components/material/Icon.module"
    import Icon from "@components/material/Icon.svelte"
    import { twMerge } from "tailwind-merge"

    export let icon: IconAnimated | null = null
    export let naked = false

    let className = ""
    export { className as class }
</script>

<div
    class={twMerge(
        " inline-flex items-center justify-center h-8 w-8 rounded-full",
        className
    )}
>
    <slot>
        {#if icon}
            <Icon {icon} class={naked ? "h-8 w-8" : "h-5 w-5"} />
        {/if}
    </slot>
</div>
